export default() => {

    const navButton = document.querySelector('.hamburger');
    if(!navButton) return;
    
    const mobileNavContainer = document.querySelector('.mobile-nav-container');
    navButton.addEventListener('click', (e) => {
        if(mobileNavContainer.classList.contains('hidden')){
            mobileNavContainer.classList.remove('hidden');
        }
        else{
            mobileNavContainer.classList.add('hidden');
        }
    });

    const mobileNavClose = document.querySelector('.mobile-nav-close-btn');
    mobileNavClose.addEventListener('click', (e) => {
        mobileNavContainer.classList.add('hidden');
    });

    const mobileMenu = document.querySelector('#mobile-menu');
    const expandableParentItems = mobileMenu.querySelectorAll('.menu-item-has-children');
    expandableParentItems.forEach( (expandableParentItem) => {
        // DC: removed submenu expand as this prevents the parent page link from being clickable 28/09/22
        // expandableParentItem.querySelector('.sub-menu').classList.add('hidden');
        
        // expandableParentItem.firstElementChild.addEventListener('click', (e) => {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     const menuItem = e.currentTarget;
        //     menuItem.classList.toggle('open');
        //     menuItem.nextElementSibling.classList.toggle('hidden');
        // }); 
    });
}